// Regla de visibilidad de la ventana de gracia de verificación (migr. 0037).
//
// Vive acá y no en la página porque es la definición de "esta gracia importa" y
// se testea sola: es TS puro, sin React ni DOM (ver el `include` de
// vitest.config.ts, mismo criterio que charts/geometry).

import type { VerificationGraceState } from '@/lib/api';

/**
 * Una semana. Pasado ese plazo la ventana ya no explica nada de lo que le pasa
 * hoy al usuario, y una pastilla permanente con información muerta es ruido que
 * le compite el lugar a las cinco que sí importan siempre.
 */
export const GRACE_STALE_SECONDS = 7 * 86_400;

/**
 * ¿Esta gracia merece ocupar una pastilla en la vista 360?
 *
 * No, si el usuario nunca tuvo una ventana (`grace_until` nulo) o si la que
 * tuvo terminó hace más de una semana. Sí, si está vigente (contador verde) o
 * si concluyó hace poco (rojo) — ahí es justamente la explicación de por qué
 * el usuario dejó de entrar de un momento a otro.
 */
export function graceWorthShowing(
  g: VerificationGraceState | null,
): g is VerificationGraceState {
  if (!g || g.grace_until === null || g.seconds_remaining === null) return false;
  return g.seconds_remaining > -GRACE_STALE_SECONDS;
}
